/** V0.2 数据源开关：true = 调真实接口（测试/生产按 PREACT_APP_ENV），false = mock 静态数据 */
export const USE_API = true;

/** 接口前缀：测试环境（自签证书需浏览器信任过）；生产走 secret-list.io */
const TEST_BASE = 'https://secret-list-test-dt.io.mlj130.com/lt';
const PROD_BASE = 'https://secret-list.io.mlj130.com/lt';
// PREACT_APP_ENV 由构建器替换为常量；浏览器无需也没有 Node.js 的 process 对象。
const LT_BASE = process.env.PREACT_APP_ENV === 'production' ? PROD_BASE : TEST_BASE;

export const API_BASE = `${LT_BASE}/live-trailer-v2`;

/* ========= gh_id 渠道透传（与老 H5 同约定：URL 带 gh_id → 请求头/参数透传） ========= */
/** 当前 URL 是渠道唯一来源；站内跳转由 withGhId 显式保留参数。 */
export function currentGhId(): string {
  try {
    return (new URLSearchParams(window.location.search).get('gh_id') ?? '').trim();
  } catch {
    return '';
  }
}

/** 站内跳转保留 gh_id：/live/xxx 链接统一加参数 */
export function withGhId(path: string): string {
  const gh = currentGhId();
  if (!gh) return path;
  return path + (path.includes('?') ? '&' : '?') + 'gh_id=' + encodeURIComponent(gh);
}
